module.exports = __webpack_public_path__ + "static/Icon_FindTeam_Large-a7a8d9c5ce82491f8bac37fe2dc38af5.png";